import { isEmpty } from '@carecloud/cloudpak';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { NavLink, useHistory } from 'react-router-dom';
import React, { useContext } from 'react';
import { store } from '../../../models';
import styles from './button.module.scss';
import { ContextProvider } from '../../root/TopLevelContext';
import * as babyContexts from '../../../contexts';
import { PageLoader } from '..';
import { MEDIUM_LOADER_SIZE, SMALL_LOADER_SIZE, SMALL_LOADER_THICKNESS } from '../../../constants/Loader';

const ButtonContainer = React.memo(
  ({ button, loader, id, type, text, theme, route, disabled, action = {}, showLoader, polling = null, image = null, activeClass=null }) => {
    const { model = String(), trigger = String(), param = String(), babyContext = String() } = action;
    const grandpaContext = useContext(ContextProvider);
    const history = useHistory();
    const variableContext = babyContext && useContext(babyContexts[`${babyContext}Context`]);
    const checkIn = () => {
      store.dispatch.notification.close();
      // store.dispatch.appointmentCheckIn.storeAppointmentData(data);
      history.push(route);
    };
    const clickHandler = _ => {
      try {
        store.dispatch.button.buttonParam({param});
        if (showLoader) {
          // For type="submit" buttons, disabling this button synchronously
          // here (via loader.persist -> isSubmitting) races the browser's
          // native default action for this same click — a submit button
          // that goes disabled before the browser gets to submit its form
          // has that submission silently cancelled, so onSubmit never fires.
          // Deferring a tick lets the native submit go through first.
          if (type === 'submit') {
            setTimeout(() => store.dispatch.loader.persistLoader({ persist: true }), 0);
          } else {
            store.dispatch.loader.persistLoader({ persist: true });
          }
        }
        if (polling) store.dispatch.button.polling({ polling });
        if (model === 'localActions' && trigger) {
          grandpaContext._getAction(trigger) && grandpaContext._getAction(trigger)(param);
        } else if (babyContext) {
          if (Object.keys(variableContext).length) {
            if (
              store.getState().radioInput.cancellationReason === 'PR' &&
              store.getState().radioInput.cancellationReasonValue === '1'
            ) {
              store.dispatch.addAppointment.setPrePaymentRescheduleInput(param)
              variableContext.rescheduleAppointment(param).then(() => {
                store.dispatch.addAppointment.setAppointmentCancelInput(param);
                // variableContext.cancelAppointment(param)
              });
              store.dispatch.radioInput.resetRadioInput();
              // if(param.practiceId !== 'ac6e00ee-5a80-49bf-8c67-f3f2218e6437' && param.practiceId !== '8f7fde47-9eae-4792-bc88-21cc059879ca') store.dispatch.radioInput.resetRadioInput();
            } else {
              variableContext[trigger](param);
            }
          } else {
            checkIn(param);
          }
        } else if (model && trigger) {
          // Showing modal at appointment check-in in absence of SSN/DL
          if (
            store.getState().modal.SNNOrDLModal &&
            model === 'form' &&
            trigger === 'toggleSubmit' &&
            store.getState().modal.showSNNorDLModal &&
            !store.getState().modal.modalOpen
          ) {
            store.dispatch.modal.toggleOpen('confirmSSNOrDLModal');
          } else {
            store.dispatch[model][trigger](param);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    // Allows form to enable/disable it's button(s)
    const enableFormDependent = _ => button[id];
    // Generic "in place of button text" loading state: any showLoader button
    // reflects the same loader.persist flag it turns on/off — same mechanism
    // as before (persistLoader), just also read here to swap in a spinner
    // instead of {text} without swapping out the whole button (unlike the
    // isPolling branch below, which was already doing a full-button swap).
    const isSubmitting = showLoader && loader.persist;
    if (!isEmpty(action) || !route) {
      const isPolling = button.polling === polling;
      return !isPolling ? (
        <button
          id={id}
          className={classNames(styles.btn, styles[theme], {
            [styles.disabled]: disabled && !enableFormDependent(),
            [styles.hidden]: button.hidden.includes(id),
          },
          activeClass && 'active')}
          type={type}
          onClick={clickHandler}
          disabled={(disabled && !enableFormDependent()) || isSubmitting}
        >
          {isSubmitting ? (
            <PageLoader className="inline" size={SMALL_LOADER_SIZE} thickness={SMALL_LOADER_THICKNESS} overlay={false} fixed={false} />
          ) : (
            <>
              {`${text} `}
              {image && <img src={image} alt="Video Visit icon" />}
            </>
          )}
        </button>
      ) : (
        <PageLoader
          className="centered"
          size={MEDIUM_LOADER_SIZE}
          thickness={SMALL_LOADER_THICKNESS}
          overlay={false}
          fixed={false}
        />
      );
    }
    return (
      <NavLink
        id={id}
        className={classNames(
          styles.btn,
          styles.nav,
          styles[theme],
          { [styles.disabled]: disabled && !enableFormDependent() },
          disabled && !enableFormDependent() ? 'disabled' : '',
        )}
        to={route}
      >
        {text}
      </NavLink>
    );
  },
);

const mapStateToProps = ({ button, loader }) => ({ button, loader });
export default connect(mapStateToProps)(ButtonContainer);
